// extracted by mini-css-extract-plugin
export default {"container":"List_container__cBkp2","list":"List_list__hwmYl","box1":"List_box1__JuG-r","icons":"List_icons__eo4Av","text1":"List_text1__62Fez","active":"List_active__vXmt5"};